import { EChartsCoreOption } from 'echarts';
import {
  ChartDataResponseResult,
  ChartProps,
  DataRecordValue,
  QueryFormColumn,
  QueryFormData,
  QueryFormMetric,
  SetDataMaskHook,
} from '@superset-ui/core';
import {
  DEFAULT_LEGEND_FORM_DATA,
  EchartsLegendFormData,
} from '../../../types';
import { LabelPosition, LabelAlignment } from '../enums';
import { RGBAColor } from '../../types';

export type EchartsCustomPieFormData = QueryFormData &
  EchartsLegendFormData & {
    groupby: QueryFormData[];
    metric: QueryFormMetric;
    showLabels: boolean;
    tooltipFormat: string;
    backgroundColor: RGBAColor;
    labelColor: RGBAColor;
    labelLineColor: RGBAColor;
    labelPosition: LabelPosition;
    labelAlignment: LabelAlignment;
    sliceColor: RGBAColor;
};

export interface EchartsCustomPieChartProps
  extends ChartProps<EchartsCustomPieFormData> {
  formData: EchartsCustomPieFormData;
  queriesData: ChartDataResponseResult[];
}

// @ts-ignore
export const DEFAULT_FORM_DATA: EchartsCustomPieFormData = {
  ...DEFAULT_LEGEND_FORM_DATA,
  groupby: [],
  showLabels: true,
  tooltipFormat: '{a} <br/>{b} : {c} ({d}%)',
  backgroundColor: { r: 44, g: 52, b: 60, a: 1 },
  labelColor: { r: 255, g: 255, b: 255, a: .3 },
  labelLineColor: { r: 250, g: 250, b: 250, a: .3 },
  labelPosition: LabelPosition.Outer,
  labelAlignment: LabelAlignment.None,
  sliceColor: { r: 194, g: 53, b: 49, a: 1 }
};

export interface CustomPieChartTransformedProps {
  formData: EchartsCustomPieFormData;
  height: number;
  width: number;
  echartOptions: EChartsCoreOption;
  setDataMask: SetDataMaskHook;
  labelMap: Record<string, DataRecordValue[]>;
  groupby: QueryFormColumn[];
}